import * as React from "react";
import styled from "@mui/material/styles/styled";
import { PatientCase } from "../../../context/diagnosticAgent";
import { CaseGenderIcon } from "../common/caseGenderIcon";
import { AgePresenter } from "../common/agePresenter";
import { ListItem } from "@mui/material";
import { QualifiedFeatureListItemText } from "../common/qualifiedFeatureListItemText";
import { MobileView } from "../../../util/aKaunGeneralUtil";
import { useScreenSize } from "../util/useScreenSize";

//region [[ Styles ]]

const PatientChartAgeGenderSectionView = styled(ListItem)({
  padding: "10px",
  display: "flex",
  minHeight: "90px",
  alignItems: "flex-start",
  marginLeft: "0px",
});

const ChiefComplaintContainer = styled("div")(({ theme }) => ({
  paddingTop: "7px",
  [theme.breakpoints.down(MobileView)]: {
    paddingLeft: "20px",
    paddingTop: "5px",
    minHeight: "50px",
  },
}));

const GenderIcon = styled("div")(({ theme }) => ({
  height: "55px",
  width: "55px",
}));

const RightArea = styled("div")(({ theme }) => ({
  display: "flex",
  marginTop: "2px",
  flexDirection: "column",
}));

const LeftArea = styled("div")(({ theme }) => ({
  marginRight: "20px",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientChartAgeGenderSectionProps {
  className?: string;
  patientCase: PatientCase;
  onEditGender?: () => void;
  onEditAge?: () => void;
  onEditChiefComplaint?: () => void;
  ageUnderGender?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientCaseWidget = ({
  ageUnderGender,
  ...props
}: PatientChartAgeGenderSectionProps) => {
  const { isMobile } = useScreenSize();

  return (
    <PatientChartAgeGenderSectionView
      className={props.className}
      onClick={props.onEditGender}
    >
      <LeftArea className={"left"}>
        <GenderIcon className={"case-gender-icon-container"}>
          <CaseGenderIcon
            className={"list-item-avatar-icon"}
            onClick={props.onEditGender}
            gender={props.patientCase.gender}
          />
        </GenderIcon>
        {ageUnderGender && (
          <AgePresenter
            className={"age-presenter"}
            onClick={props.onEditAge}
            textSize={"small"}
            age={props.patientCase.age}
          />
        )}
      </LeftArea>
      <RightArea className={"right"}>
        {!ageUnderGender && (
          <AgePresenter
            onClick={props.onEditAge}
            textSize={"small"}
            age={props.patientCase.age}
          />
        )}
        <ChiefComplaintContainer onClick={props.onEditChiefComplaint}>
          <QualifiedFeatureListItemText
            hideRefinement={isMobile}
            qualifiedFeature={props.patientCase.main}
            onEditFeature={props.onEditChiefComplaint}
            emptyText={"Chief complaint"}
          />
        </ChiefComplaintContainer>
      </RightArea>
    </PatientChartAgeGenderSectionView>
  );
};
